import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// English
import enCommon from '@shared/i18n/locales/en/common.json';
import enAuth from '@shared/i18n/locales/en/auth.json';
import enHome from '@shared/i18n/locales/en/home.json';
import enEvent from '@shared/i18n/locales/en/event.json';
import enGuest from '@shared/i18n/locales/en/guest.json';
import enProfile from '@shared/i18n/locales/en/profile.json';

// Turkish
import trCommon from '@shared/i18n/locales/tr/common.json';
import trAuth from '@shared/i18n/locales/tr/auth.json';
import trHome from '@shared/i18n/locales/tr/home.json';
import trEvent from '@shared/i18n/locales/tr/event.json';
import trGuest from '@shared/i18n/locales/tr/guest.json';
import trProfile from '@shared/i18n/locales/tr/profile.json';

// German
import deCommon from '@shared/i18n/locales/de/common.json';
import deAuth from '@shared/i18n/locales/de/auth.json';
import deHome from '@shared/i18n/locales/de/home.json';
import deEvent from '@shared/i18n/locales/de/event.json';
import deGuest from '@shared/i18n/locales/de/guest.json';
import deProfile from '@shared/i18n/locales/de/profile.json';

// Planner-specific translations
import enPlanner from './locales/en/planner.json';
import trPlanner from './locales/tr/planner.json';
import dePlanner from './locales/de/planner.json';

// Agent-specific translations
import enAgent from './locales/en/agent.json';
import trAgent from './locales/tr/agent.json';
import deAgent from './locales/de/agent.json';

export const SUPPORTED_LANGUAGES = {
  en: { name: 'English', flag: '🇺🇸' },
  tr: { name: 'Türkçe', flag: '🇹🇷' },
  de: { name: 'Deutsch', flag: '🇩🇪' },
} as const;

export type SupportedLanguage = keyof typeof SUPPORTED_LANGUAGES;

const resources = {
  en: {
    common: enCommon,
    auth: enAuth,
    home: enHome,
    event: enEvent,
    guest: enGuest,
    profile: enProfile,
    planner: enPlanner,
    agent: enAgent,
  },
  tr: {
    common: trCommon,
    auth: trAuth,
    home: trHome,
    event: trEvent,
    guest: trGuest,
    profile: trProfile,
    planner: trPlanner,
    agent: trAgent,
  },
  de: {
    common: deCommon,
    auth: deAuth,
    home: deHome,
    event: deEvent,
    guest: deGuest,
    profile: deProfile,
    planner: dePlanner,
    agent: deAgent,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'auth', 'home', 'event', 'guest', 'profile', 'planner', 'agent'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'eventroy_language',
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
